import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { t } from "./releases/t";

const RELEASE_URL = "https://matsuri-releases-api.vercel.app/product";

@customElement("m2m-releases-link")
export class M2mReleaseLink extends LitElement {
  static readonly styles = css`
    :host a {
      display: block;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      padding: 0px;
      color: rgba(0, 0, 0, 0.87);
      cursor: pointer;
      background-color: transparent;
      border: none;
      transition: background-color 0.2s ease 0s;
      appearance: none;
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
  `;

  declare product: string;
  static properties = {
    product: {
      type: String,
      attribute: "product",
    },
  };

  constructor() {
    super();
    this.product = "";
  }

  render() {
    return html`<a
      href="${RELEASE_URL}/${this.product}?t=${t}"
      target="_blank"
      rel="noopener noreferrer"
      title="リリース情報"
    >
      <span></span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32px"
        height="32px"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5zm-2 0C14.5 6.47 12.03 4 9 4S3.5 6.47 3.5 9.5c0 2.47 1.49 3.89 2.35 4.5h6.3c.86-.61 2.35-2.03 2.35-4.5zm6.87-2.13L20 8l1.37.63L22 10l.63-1.37L24 8l-1.37-.63L22 6l-.63 1.37zM19 6l.94-2.06L22 3l-2.06-.94L19 0l-.94 2.06L16 3l2.06.94L19 6z"
        />
      </svg>
    </a>`;
  }
}
